import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import AboutUsComponent from './../../../Components/UserComponents/AboutUs/index';
import {getPbssInternationalById} from '../../../Store/Actions/pbssInternational';
import {httpClient} from '../../../Api/client';
import Urls from '../../../Constant/Urls';
import {HttpCode} from '../../../Constant/HttpCode';
import {applicationConfig} from '../../../Util/config';

const AboutUsContainer = () => {
  const dispatch = useDispatch();
  const {allPbssInternational} = useSelector(
    ({pbssInternational}) => pbssInternational,
  );

  const [pbssIntroHtml, setPbssIntroHtml] = useState('');
  const [ourMissionHtml, setOurMissionHtml] = useState('');
  const [aboutUsImageUrl, setAboutUsImageUrl] = useState('');
  const [leadershipMembers, setLeadershipMembers] = useState([]);
  const [operationsMembers, setOperationsMembers] = useState([]);
  const [distinguishedAdvisorsMembers, setDistinguishedAdvisorsMembers] = useState([]);
  const [programManagementMembers, setProgramManagementMembers] = useState([]);

  useEffect(() => {
    dispatch(getPbssInternationalById());
  }, []);

  useEffect(() => {
    // Check if data exists and is not false (initial state)
    if (allPbssInternational && allPbssInternational !== false) {
      const record = allPbssInternational?.data?.pbssInternational?.[0];
      if (record) {
        setPbssIntroHtml(record?.pbss_intro || '');
        setOurMissionHtml(record?.our_mission || '');
        
        let imageName = record?.about_us_image_id?.name ?? null;
        
        if (imageName && applicationConfig.UPLOAD_URL) {
          const imageUrl = `${applicationConfig.UPLOAD_URL}/${imageName}`;
          setAboutUsImageUrl(imageUrl);
        } else {
          setAboutUsImageUrl('');
        }
      } else {
        setPbssIntroHtml('');
        setOurMissionHtml('');
        setAboutUsImageUrl('');
      }
    }
  }, [allPbssInternational]);

  useEffect(() => {
    let isMounted = true;

    const fetchMembers = async (aboutUsType) => {
      const url = `${Urls.COMMITTEE_MEMBERS_GET_ALL}?page=1&pageCount=100&sortField=order_number&sortOrder=asc&type=about_us&about_us_type=${aboutUsType}`;
      const res = await httpClient.get(url);
      if (res?.status !== HttpCode.Ok) return [];
      return res?.data?.data?.committeeMembers || res?.data?.data || [];
    };

    (async () => {
      try {
        const [leadership, operations, distinguishedAdvisors, programManagement] =
          await Promise.all([
            fetchMembers('leadership'),
            fetchMembers('operations'),
            fetchMembers('distinguish_advisor'),
            fetchMembers('program_management'),
          ]);
        if (!isMounted) return;
        setLeadershipMembers(Array.isArray(leadership) ? leadership : []);
        setOperationsMembers(Array.isArray(operations) ? operations : []);
        setDistinguishedAdvisorsMembers(
          Array.isArray(distinguishedAdvisors) ? distinguishedAdvisors : [],
        );
        setProgramManagementMembers(
          Array.isArray(programManagement) ? programManagement : [],
        );
      } catch (e) {
        if (!isMounted) return;
        setLeadershipMembers([]);
        setOperationsMembers([]);
        setDistinguishedAdvisorsMembers([]);
        setProgramManagementMembers([]);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <AboutUsComponent
      pbssIntroHtml={pbssIntroHtml}
      ourMissionHtml={ourMissionHtml}
      aboutUsImageUrl={aboutUsImageUrl}
      leadershipMembers={leadershipMembers}
      operationsMembers={operationsMembers}
      distinguishedAdvisorsMembers={distinguishedAdvisorsMembers}
      programManagementMembers={programManagementMembers}
    />
  );
};

export default AboutUsContainer;
